"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasPermission = (permission, user) => {
    if (!user || !user.roles || !user.permissions) {
        return false;
    }
    const userIsDev = user.roles.find(role => role.name === 'dev');
    const roleHasPermission = user.roles.find(role => role.permissions.find(perm => perm.name === permission));
    const userHasPermission = user.permissions.find(perm => perm.name === permission);
    return !!userIsDev || !!roleHasPermission || !!userHasPermission;
};
exports.hasRole = (role, user) => {
    if (!user || !user.roles) {
        return false;
    }
    for (const userRole of user.roles) {
        if (userRole.name === role) {
            return true;
        }
    }
    return false;
};
